import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();

  const footerStyle = {
    backgroundColor: "#f8f9fa",
    padding: "5px 0",
    width: "100%",
    borderTop: "1px solid #e7e7e7",
    marginTop: "2rem",
  };

  const contentStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 1rem",
    color: "#666",
    fontSize: "0.85rem",
    lineHeight: 1.5,
    textAlign: "center",
  };

  const copyrightStyle = {
    marginBottom: "0.75rem",
  };

  const legalStyle = {
    margin: 0,
    fontSize: "0.8rem",
  };

  return (
    <footer style={footerStyle}>
      <div style={contentStyle}>
        <p style={copyrightStyle}>
          &copy; {currentYear} TCS. All rights reserved. The content, design,
          graphics, and other materials on this site are protected by copyright
          and other laws.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
